import { Link } from "react-router-dom";
import navigators from "../../Common/nav";
import LinkComponent from "./LinkComponent";

function Nevigation({role}) {
  // const cont = useContext(UserContext);

  return (
    <div
      style={{
        width: "240px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "16px",
      }}
      className="left navside dark dk"
    >
      <div>
        <Link to="/">
          <img src="/logo.png" alt="." width={"100%"} />
        </Link>
      </div>
      <ul>
        {navigators
          .filter((key) => key.role.includes(role))
          .map((key) => (
            <LinkComponent key={key.label} {...key} role={role} />
          ))}
      </ul>
    </div>
  );
}

export default Nevigation;
